export default __webpack_public_path__ + "images/DU.b0687f6.png";